// extracted by mini-css-extract-plugin
export var box = "_9a-1";
export var checked = "_9a-2";
export var descriptionSpacer = "_9a-9";
export var disabled = "_9a-3";
export var icon = "_9a-6";
export var input = "_9a-0";
export var labelSpacer = "_9a-8";
export var medium = "_9a-5";
export var small = "_9a-4";
export var text = "_9a-7";